import React, { Component } from "react";

class ContactUs extends Component {
  render() {
    return (
      <div className="container padded page">
        <h1>Contáctanos</h1>
        <p className="lead">
          Simplemente manda un email a{" "}
          <a href="mailto:elprofeshop@gmail.com">elprofeshop@gmail.com</a>.
        </p>
        <p className="lead">
          Agradecemos sugerencias y funcionalidad que les gustaría ver en un
          futuro.
        </p>
        <p className="lead">¡Gracias!</p>
      </div>
    );
  }
}

export default ContactUs;



// WEBPACK FOOTER //
// ./src/components/ContactUs.js